/*=========================================================================================
  File Name: moduleCourseRegistrationActions.js
  Description: CourseRegistration Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {

    return new Promise((resolve, reject) => {
      axios.post("api/CourseRegistration/AddCourseRegistration", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchDataListItems({ commit }) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseRegistration/GetAll")
        .then((response) => {
          commit('SET_CourseRegistrations', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  searchCourseRegistration({ commit }, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRegistration/searchCourseRegistration", search)
        .then((response) => {
          commit('SET_CourseRegistrations', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  searchMainCourseRegistration({ commit }, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRegistration/searchMainCourseRegistration", search)
        .then((response) => {
          commit('SET_CourseRegistrations', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetRegistrationStatus(context, code) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseRegistration/GetRegistrationStatus?Code=" + code)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  RegisterConfirm(context, code) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseRegistration/RegisterConfirm?Code=" + code)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItem(context, item) {
    return new Promise((resolve, reject) => {
      axios.put("api/CourseRegistration/UpdateCourseRegistration?ID=" + item.ID, item)
        .then((response) => {

          //commit('UPDATE_CourseRegistration', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByID(context, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("API/CourseRegistration/GetCourseRegistration?ID=" + itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, item) {

    return new Promise((resolve, reject) => {
      axios.delete("API/CourseRegistration/DeleteCourseRegistration?courseRegistrationID=" + item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeContact(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/CourseRegistration/DeleteCourseRegistrationContact?ID=" + item.ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SaveTraineePassport(context, data) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRegistration/SaveTraineePassport", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SavePaymentProof(context, pay) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRequest/SavePaymentProof", pay)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SaveVisaProof(context, visa) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRegistration/SaveVisaProof", visa)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SaveFlightTicket(context, visa) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseRegistration/SaveFlightTicket", visa)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseRegistrationsByTraineeID({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseRegistration/GetCourseRegistrationsByTraineeID")
        .then((response) => {
          commit('SET_CourseRegistrations', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

}
